import Konva from 'konva';
import * as state from '../state.js';
import { attachInteractive, pointerPos } from './_helpers.js';

let active = null;
let startX = 0;
let startY = 0;

export const rectangle = {
  id: 'rectangle',
  defaultProps: { fill: false, radius: 6 },
  onPointerDown(engine) {
    const pos = pointerPos(engine);
    if (!engine.pointerInsideImage(pos)) return;
    startX = pos.x;
    startY = pos.y;
    const defaults = state.get('toolDefaults').rectangle ?? this.defaultProps;
    active = new Konva.Rect({
      x: startX,
      y: startY,
      width: 0,
      height: 0,
      stroke: state.get('selectedColor'),
      strokeWidth: state.get('strokeWidth'),
      fill: defaults.fill ? state.get('selectedColor') : 'transparent',
      cornerRadius: defaults.radius,
    });
    engine.contentLayer.add(active);
  },
  onPointerMove(engine) {
    if (!active) return;
    const pos = pointerPos(engine);
    const w = pos.x - startX;
    const h = pos.y - startY;
    active.setAttrs({
      x: w < 0 ? pos.x : startX,
      y: h < 0 ? pos.y : startY,
      width: Math.abs(w),
      height: Math.abs(h),
    });
    engine.contentLayer.batchDraw();
  },
  onPointerUp(engine) {
    if (!active) return;
    if (active.width() < 2 || active.height() < 2) {
      active.destroy();
    } else {
      active.remove();
      attachInteractive(engine, active);
    }
    engine.contentLayer.batchDraw();
    active = null;
  },
  apply(node, prop, value) {
    if (prop === 'color') {
      node.stroke(value);
      const fill = node.fill();
      if (fill && fill !== 'transparent') node.fill(value);
    } else if (prop === 'strokeWidth') {
      node.strokeWidth(value);
    } else if (prop === 'fill') {
      node.fill(value ? state.get('selectedColor') : 'transparent');
    } else if (prop === 'radius') {
      node.cornerRadius(value);
    }
  },
};
